module.exports = __webpack_public_path__ + "portal-static/img/data.7885703e.png";